module.exports = __webpack_public_path__ + "static/media/vitaldetails1.f42b759a.png";